import { Button, Narrator, Page } from '../components/ui';
import { go } from '../state/actions';

export function ReclaimWaiting({ code, playerName }: { code: string; playerName: string }) {
  return (
    <Page title="Reclaim seat">
      <div className="callout">
        <p>
          Asking the host of game <strong>{code}</strong> to return <strong>{playerName}</strong>’s seat to this phone.
        </p>
        <Narrator>Your request has been forwarded to the appropriate office.</Narrator>
      </div>
      <Button variant="secondary" onClick={() => go({ name: 'join', code, playerName })}>
        Cancel
      </Button>
    </Page>
  );
}
